<template>
  <div v-if="status === 'down'" class="c-notification-banner is-active">
    We're currently experiencing issues with our booking system, please check back soon or call us on 01524 701508
  </div>
  <GlobalNotificationBanner v-else />
</template>

<script setup>
const status = ref('unknown')

// Defer fetch until browser is idle or settled
onMounted(() => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(fetchStatus)
  } else {
    setTimeout(fetchStatus, 200) // fallback
  }
})

async function fetchStatus() {
  try {
    const res = await $fetch('/api/booking/health')
    status.value = res.status ?? 'unknown'
  } catch (e) {
    status.value = 'unknown'
  }
}
</script>
